export enum PasswordAction {
  CHANGE = 'reset2fa/PASSWORD_CHANGE',
  ERROR = 'reset2fa/PASSWORD_ERROR',
}

export enum UsernameAction {
  CHANGE = 'reset2fa/USERNAME_CHANGE',
  ERROR = 'reset2fa/USERNAME_ERROR',
}
